(function () {
  function initRetroDialup() {
    document.querySelectorAll('[data-retro-dialup]').forEach(function (el) {
      var fill = el.querySelector('[data-retro-dialup-fill]');
      var pct = el.querySelector('[data-retro-dialup-pct]');
      if (!fill || !pct) return;
      var value = 0;
      var timer = setInterval(function () {
        value += Math.floor(Math.random() * 9) + 3;
        if (value >= 100) { value = 100; clearInterval(timer); }
        fill.style.transform = 'scaleX(' + (value / 100) + ')';
        pct.textContent = value;
      }, 220);
    });
  }

  function initRetroCountdown() {
    document.querySelectorAll('[data-retro-countdown]').forEach(function (el) {
      var end = new Date(el.getAttribute('data-end').replace(' ', 'T')).getTime();
      var daysEl = el.querySelector('[data-days]');
      var hoursEl = el.querySelector('[data-hours]');
      var minutesEl = el.querySelector('[data-minutes]');
      var secondsEl = el.querySelector('[data-seconds]');
      if (!daysEl || !hoursEl || !minutesEl || !secondsEl) return;

      function pad(n) { return String(n).padStart(2, '0'); }

      function tick() {
        var diff = end - Date.now();
        if (isNaN(end) || diff <= 0) {
          daysEl.textContent = hoursEl.textContent = minutesEl.textContent = secondsEl.textContent = '00';
          return;
        }
        daysEl.textContent = pad(Math.floor(diff / 86400000));
        hoursEl.textContent = pad(Math.floor((diff / 3600000) % 24));
        minutesEl.textContent = pad(Math.floor((diff / 60000) % 60));
        secondsEl.textContent = pad(Math.floor((diff / 1000) % 60));
      }

      tick();
      setInterval(tick, 1000);
    });
  }

  function boot() {
    // Guard: this file may be included by more than one section (hero + countdown
    // both reference it) — only run init once no matter how many times it loads.
    if (window.__retroSectionsInit) return;
    window.__retroSectionsInit = true;
    initRetroDialup();
    initRetroCountdown();
  }

  function schedule() {
    // These are decorative widgets, not needed for first paint — defer them
    // off the critical rendering path so they never compete with LCP/FCP.
    if ('requestIdleCallback' in window) {
      requestIdleCallback(boot, { timeout: 1000 });
    } else {
      setTimeout(boot, 50);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
})();